import { render } from "./WebPayTransactions.vue?vue&type=template&id=6f4b7c6c&scoped=true"
import script from "./WebPayTransactions.vue?vue&type=script&lang=js"
export * from "./WebPayTransactions.vue?vue&type=script&lang=js"

import "./WebPayTransactions.vue?vue&type=style&index=0&id=6f4b7c6c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4b7c6c"]])

export default __exports__